export { default } from './maritalStatusOptions'
export * from './maritalStatusOptions'
